export default __webpack_public_path__ + "static/media/subscription-cancelled.ead678e0.svg";